import { render, staticRenderFns } from "./WebpayNotificationPayments.vue?vue&type=template&id=5a104d00&"
import script from "./WebpayNotificationPayments.vue?vue&type=script&lang=js&"
export * from "./WebpayNotificationPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports